import Swal from "sweetalert2";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const askReportFormat = async () => {
  const { value, isConfirmed } = await Swal.fire({
    title: "Download Report",
    text: "Select the report format",
    input: "radio",
    inputOptions: { csv: "CSV", excel: "Excel", json: "JSON" },
    inputValue: "csv",
    confirmButtonText: "Download",
    showCancelButton: true,
  });
  return isConfirmed ? value : null;
};

// rows[0] is the header row
export const saveReport = (rows, format, baseName) => {
  const date = new Date().toISOString().slice(0, 10);
  const fileName = `${baseName}_${date}`;
  const [header, ...body] = rows;

  if (format === "excel") {
    const sheet = XLSX.utils.aoa_to_sheet(rows);
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, sheet, "Report");
    XLSX.writeFile(book, `${fileName}.xlsx`);
  } else if (format === "json") {
    const json = body.map((row) =>
      header.reduce((item, label, index) => ({ ...item, [label]: row[index] }), {})
    );
    saveAs(new Blob([JSON.stringify(json, null, 2)], { type: "application/json" }), `${fileName}.json`);
  } else {
    const csv = Papa.unparse(rows);
    saveAs(new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8;" }), `${fileName}.csv`);
  }
};
